import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

interface PageContentAnimationProps {
  className?: string;
  children: React.ReactNode;
  animateAlways?: boolean;
}

export const PageContentAnimation = ({ className, children, animateAlways }: PageContentAnimationProps) => {
  const location = useLocation();
  return (
    <motion.div
      key={animateAlways ? location.pathname : 'none'}
      data-component="PageContentAnimation"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        opacity: { ease: 'linear', duration: 0.2 },
        y: { ease: 'easeInOut', duration: 0.4 },
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
